import { ServerModelWithDateStrings } from "@teamprevent/common/utils";
import axios from "axios";

import { Statistics } from "./models";

export const getStatistics = async (): Promise<Statistics> => {
    const response = await axios.get<ServerModelWithDateStrings<Statistics>>("/api/statistics");
    return parseResponseModel(response.data);
};

const parseResponseModel = (model: ServerModelWithDateStrings<Statistics>): Statistics => {
    return {
        ...model,
        adminStatistics: {
            ...model.adminStatistics,
            lastUpdated: model.adminStatistics.lastUpdated ? new Date(model.adminStatistics.lastUpdated) : null
        },
        adminUserStatistics: {
            ...model.adminUserStatistics,
            lastUpdated: model.adminUserStatistics.lastUpdated ? new Date(model.adminUserStatistics.lastUpdated) : null
        }
    };
};
